import React, {
  useState,
  useEffect
} from "react";

import {
  gql,
  useQuery
} from "@apollo/client";

// =========================
// QUERY PRODUCTOS
// =========================
const GET_PRODUCTOS = gql`
  query GetProductos {
    getProductos {
      _id
      nombre
      proveedores
    }
  }
`;

function PreciosProveedores() {

  // =========================
  // FILTRO PRODUCTO
  // =========================
  const [busquedaProducto, setBusquedaProducto] =
    useState("");

  // =========================
  // FILTRO PROVEEDOR
  // =========================
  const [busquedaProveedor, setBusquedaProveedor] =
    useState("");

  // =========================
  // CARRITO
  // =========================
  const [carrito, setCarrito] =
    useState([]);

  // =========================
  // MODAL
  // =========================
  const [mostrarModal, setMostrarModal] =
    useState(false);

  // =========================
  // QUERY
  // =========================
  const {
    loading,
    error,
    data
  } = useQuery(GET_PRODUCTOS);

  // =========================
  // CARGAR LOCALSTORAGE
  // =========================
  useEffect(() => {

    const carritoGuardado =
      localStorage.getItem("carrito");

    if (carritoGuardado) {
      setCarrito(
        JSON.parse(carritoGuardado)
      );
    }

  }, []);

  // =========================
  // GUARDAR LOCALSTORAGE
  // =========================
  useEffect(() => {

    localStorage.setItem(
      "carrito",
      JSON.stringify(carrito)
    );

  }, [carrito]);

  // =========================
  // AGREGAR AL CARRITO
  // =========================
  const agregarAlCarrito = (
    producto
  ) => {

    const existe = carrito.find(
      (item) =>
        item._id === producto._id
    );

    if (existe) {
      alert(
        "Producto ya agregado"
      );
      return;
    }

    // =========================
    // PROVEEDOR SELECCIONADO
    // =========================
    const proveedorSeleccionado =
      busquedaProveedor ||
      "Sin proveedor";

    // =========================
    // NUEVO PRODUCTO
    // =========================
    const productoConFecha = {
      ...producto,
      proveedorSeleccionado,
      fechaAgregado:
        new Date().toLocaleString()
    };

    setCarrito([
      ...carrito,
      productoConFecha
    ]);
  };

  // =========================
  // ELIMINAR DEL CARRITO
  // =========================
  const eliminarDelCarrito = (
    id
  ) => {

    const nuevoCarrito =
      carrito.filter(
        (item) =>
          item._id !== id
      );

    setCarrito(nuevoCarrito);
  };

  // =========================
  // LOADING
  // =========================
  if (loading) {
    return <p>Cargando...</p>;
  }

  // =========================
  // ERROR
  // =========================
  if (error) {
    return (
      <p>
        Error: {error.message}
      </p>
    );
  }

  // =========================
  // FILTRAR PRODUCTOS
  // =========================
  const productosFiltrados =
    data?.getProductos
      ?.filter((producto) => {

        // =========================
        // FILTRO PRODUCTO
        // =========================
        const coincideProducto =
          producto.nombre
            ?.toLowerCase()
            .includes(
              busquedaProducto.toLowerCase()
            );

        // =========================
        // PROVEEDORES
        // =========================
        const proveedores =
          Array.isArray(
            producto.proveedores
          )
            ? producto.proveedores
            : [
                producto.proveedores
              ];

        // =========================
        // FILTRO PROVEEDOR
        // =========================
        const coincideProveedor =
          !busquedaProveedor
            ? true
            : proveedores.some(
                (prov) =>
                  prov
                    ?.toLowerCase()
                    .includes(
                      busquedaProveedor.toLowerCase()
                    )
              );

        return (
          coincideProducto &&
          coincideProveedor
        );

      })

      // =========================
      // ORDENAR
      // =========================
      ?.sort((a, b) =>
        a.nombre
          .toLowerCase()
          .localeCompare(
            b.nombre.toLowerCase()
          )
      ) || [];

  return (
    <div
      style={{
        padding: 20
      }}
    >

      {/* ========================= */}
      {/* BOTÓN CARRITO */}
      {/* ========================= */}
      <button
        onClick={() =>
          setMostrarModal(true)
        }
        style={{
          marginBottom: 20,
          background: "#045712",
          color: "#fff",
          border: "none",
          padding: "12px 20px",
          borderRadius: 10,
          cursor: "pointer",
          fontSize: 16
        }}
      >
        ver pedidos
      </button>

      {/* ========================= */}
      {/* INPUTS */}
      {/* ========================= */}
      <div
        style={{
          display: "flex",
          gap: 15,
          flexWrap: "wrap",
          marginBottom: 25
        }}
      >

        {/* PRODUCTO */}
        <input
          type="text"
          placeholder="Buscar producto..."
          value={busquedaProducto}
          onChange={(e) =>
            setBusquedaProducto(
              e.target.value
            )
          }
          style={{
            flex: 1,
            minWidth: 250,
            padding: 12,
            borderRadius: 10,
            border:
              "1px solid #ccc",
            fontSize: 16
          }}
        />

        {/* PROVEEDOR */}
        <input
          type="text"
          placeholder="Buscar proveedor..."
          value={busquedaProveedor}
          onChange={(e) =>
            setBusquedaProveedor(
              e.target.value
            )
          }
          style={{
            flex: 1,
            minWidth: 250,
            padding: 12,
            borderRadius: 10,
            border:
              "1px solid #ccc",
            fontSize: 16
          }}
        />

      </div>

      {/* ========================= */}
      {/* TARJETAS */}
      {/* ========================= */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit,minmax(320px,1fr))",
          gap: 20
        }}
      >

        {productosFiltrados.map(
          (producto) => (

            <div
              key={producto._id}
              style={{
                border:
                  "1px solid #ddd",
                borderRadius: 12,
                padding: 20,
                background:
                  "#00ff4c1c",
                boxShadow:
                  "0 2px 8px rgba(0,0,0,0.1)"
              }}
            >

              <h4
                style={{
                  color: "#000",
                  marginBottom: 10
                }}
              >
                {producto.nombre}
              </h4>

              <h5
                style={{
                  color: "#154d1d"
                }}
              >
                <strong>
                  Proveedores:
                </strong>{" "}

                {Array.isArray(
                  producto.proveedores
                )
                  ? producto.proveedores.join(
                      ", "
                    )
                  : producto.proveedores ||
                    "sin agregar"}
              </h5>

              {/* BOTÓN */}
              <button
                onClick={() =>
                  agregarAlCarrito(
                    producto
                  )
                }
                className="btn btn-salida"
              >
                Agregar
              </button>

            </div>
          )
        )}

      </div>

    </div>
  );
}

export default PreciosProveedores;